import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { location as getLocation } from '@app/selectors/routing';
import { trackHomePageViewed } from './widgets/common/analytics';
import {
  HOME_LOGIN_NAV,
  HOME_BACK_BUTTON_NAV,
  HOME_DIRECT_LINK_NAV,
} from './widgets/common/homeAnalyticsConstants';

const trackedLocations = new WeakSet();

export const useTrackHomePageViewed = () => {
  const routingLocation = useSelector(getLocation) as any;
  const pathname = routingLocation?.pathname ?? '';
  const trackRef = useRef(false);

  useEffect(() => {
    if (pathname.includes('/home')) {
      if (!trackRef.current) {
        if (routingLocation && trackedLocations.has(routingLocation)) {
          trackRef.current = true;
          return;
        }

        trackRef.current = true;

        if (routingLocation) {
          trackedLocations.add(routingLocation);
        }

        if (routingLocation?.state?.tracked) {
          return;
        }

        if (routingLocation?.state?.source === 'back_button') {
          trackHomePageViewed(HOME_BACK_BUTTON_NAV);
          return;
        }

        const action = routingLocation?.action;
        const isInitialAppLoad = !(window as any).APP_HAS_LOADED;
        if (isInitialAppLoad) {
          (window as any).APP_HAS_LOADED = true;
        }

        if (action === 'POP') {
          if (!isInitialAppLoad) {
            trackHomePageViewed(HOME_BACK_BUTTON_NAV);
          } else {
            const isLogin =
              document.referrer &&
              document.referrer.includes('general.aula.education');
            trackHomePageViewed(
              isLogin ? HOME_LOGIN_NAV : HOME_DIRECT_LINK_NAV
            );
          }
        } else if (action === 'PUSH' || action === 'REPLACE') {
          const isLogin =
            document.referrer &&
            document.referrer.includes('general.aula.education');
          trackHomePageViewed(isLogin ? HOME_LOGIN_NAV : HOME_DIRECT_LINK_NAV);
        }
      }
    }
  }, [pathname, routingLocation]);
};
